import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import moment from 'moment'
import { extendObservable, action } from 'mobx'
import enhanceWithClickOutside from 'react-click-outside'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import IconButton from '@material-ui/core/IconButton'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import DateRangeIcon from '@material-ui/icons/DateRange'
import MonthYearCalendar from '@components/MonthPicker/MonthYearCalendar'
import Tooltip from '@components/Tooltip'
import PeopleIcon from '@material-ui/icons/People'

import { formatNoDecimalBigInt, formatNoDecimal, formatDecimal } from '@atheneum/api/dist/lib'

import WidgetBox from '../WidgetBox'
import Select from '@components/Select'
import AccountRevenueMobile from './AccountRevenueMobile'

class AccountRevenue extends Component {
  static propTypes = {
    dashboardStore: PropTypes.object,
    accountRevenue: PropTypes.shape({
      accounts: PropTypes.object,
      accountManager: PropTypes.string
    }),
    accountRevenueQuarterly: PropTypes.object,
    activeTeamId: PropTypes.number,
    setDate: PropTypes.func,
    date: PropTypes.string,
    setQuarter: PropTypes.func,
    setYear: PropTypes.func,
    quarter: PropTypes.number,
    year: PropTypes.number
  }

  constructor(props) {
    super(props)

    extendObservable(this, {
      isCalendarShown: false,
      quarterlyTabActive: false
    })

    this.datePicker = null
  }

  setQuarterlyTab = value => {
    this.quarterlyTabActive = value
  }

  handleCalendarDisplay = () => {
    this.isCalendarShown = true
  }

  handleClickOutside = () => {
    this.closeCalendar()
  }

  closeCalendar = () => {
    this.isCalendarShown = false
  }

  handleDateChange = action(date => {
    const { getAccountRevenueWidgetData } = this.props.dashboardStore
    this.props.setDate(date)

    const newDate = moment(date).format('MM-YYYY')

    !this.props.activeTeamId
      ? getAccountRevenueWidgetData(newDate)
      : getAccountRevenueWidgetData(newDate, this.props.activeTeamId)
  })

  onMonthPress = monthAndYear => {
    this.isCalendarShown = false
    this.handleDateChange(monthAndYear)
  }

  handleQuarterChange = action(event => {
    const quarter = event.target.value
    const { getAccountRevenueQuarterlyWidgetData } = this.props.dashboardStore
    this.props.setQuarter(quarter)

    !this.props.activeTeamId
      ? getAccountRevenueQuarterlyWidgetData({
          quarter,
          year: this.props.year
        })
      : getAccountRevenueQuarterlyWidgetData({
          quarter,
          year: this.props.year,
          teamId: this.props.activeTeamId
        })
  })

  handleYearChange = action(event => {
    const { getAccountRevenueQuarterlyWidgetData } = this.props.dashboardStore
    const year = event.target.value
    this.props.setYear(year)

    !this.props.activeTeamId
      ? getAccountRevenueQuarterlyWidgetData({
          quarter: this.props.quarter,
          year
        })
      : getAccountRevenueQuarterlyWidgetData({
          quarter: this.props.quarter,
          year,
          teamId: this.props.activeTeamId
        })
  })

  quarterlyYearOptions = initialYear => {
    const options = []
    const currentYear = new Date().getFullYear()
    for (let i = initialYear; i <= currentYear; i++) {
      options.push(i)
    }

    return options
  }

  render() {
    const { getAccountRevenueMonthlyTotals, getAccountRevenueQuarterlyTotals } =
      this.props.dashboardStore

    if (!this.props.accountRevenue || !this.props.accountRevenueQuarterly) {
      return null
    }

    const fontStyles = {
      fontSize: 14,
      fontFamily: "'Open Sans', sans-serif",
      color: '#33343A'
    }

    const totalStyles = {
      ...fontStyles,
      color: '#D0D0D0'
    }

    const useRowStyles = makeStyles({
      root: {
        '& > *': {
          borderBottom: 'unset',
          ...fontStyles
        }
      },
      head: {
        ...fontStyles,
        fontWeight: 700
      }
    })

    const monthlyTotals = getAccountRevenueMonthlyTotals()
    const quarterlyTotals = getAccountRevenueQuarterlyTotals()

    const monthlyTotal = total => {
      return (
        <TableRow key="total" style={totalStyles}>
          <TableCell component="th" scope="row" style={totalStyles}>
            <strong>Total</strong>
          </TableCell>
          <TableCell />
          <TableCell align="right" style={totalStyles}>
            {formatNoDecimal(total.ES)}
          </TableCell>
          <TableCell align="right" style={totalStyles}>
            {formatNoDecimal(total.EBR)}
          </TableCell>
          <TableCell align="right" style={totalStyles}>
            {formatNoDecimal(total.ESR)}
          </TableCell>
          <TableCell align="right" style={totalStyles}>
            {formatNoDecimal(total.EP)}
          </TableCell>
        </TableRow>
      )
    }

    function createAccountData(account) {
      return {
        accountName: account.accountName,
        ES: account.ES || '-',
        EBR: account.EBR || '-',
        ESR: account.ESR || '-',
        EP: account.EP || '-',
        offices: account.offices?.map(office => createOfficeData(office)) || []
      }
    }

    function createOfficeData(office) {
      return {
        officeName: office.officeName,
        ES: office.ES || '-',
        EBR: office.EBR || '-',
        ESR: office.ESR || '-',
        EP: office.EP || '-'
      }
    }
    function Row(props) {
      const { row } = props
      const [open, setOpen] = React.useState(false)
      const classes = useRowStyles()
      const rowStyle = {
        fontWeight: open ? '700' : 'normal'
      }

      return (
        <React.Fragment>
          <TableRow
            key="account"
            className={classes.root}
            style={{
              backgroundColor: open ? '#CCE4F6' : '#fff',
              borderBottom: open ? 'none' : '1px solid #D0D0D0'
            }}>
            <TableCell component="th" scope="row" style={rowStyle}>
              {row.accountName}
            </TableCell>
            <TableCell>
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}>
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </TableCell>
            <TableCell align="right" style={rowStyle}>
              {formatNoDecimalBigInt(row.ES)}
            </TableCell>
            <TableCell align="right" style={rowStyle}>
              {formatNoDecimalBigInt(row.EBR)}
            </TableCell>
            <TableCell align="right" style={rowStyle}>
              {formatNoDecimalBigInt(row.ESR)}
            </TableCell>
            <TableCell align="right" style={rowStyle}>
              {formatNoDecimalBigInt(row.EP)}
            </TableCell>
          </TableRow>
          {row.offices.map((office, index) => (
            <TableRow
              key={index}
              className={classes.root}
              style={{
                display: open ? 'table-row' : 'none',
                backgroundColor: '#CCE4F6',
                borderBottom:
                  index === row.offices.length - 1
                    ? '1px solid #D0D0D0'
                    : 'none'
              }}>
              <TableCell component="th" scope="row">
                <ul style={{ margin: 0 }}>
                  <li key="0">{office.officeName}</li>
                </ul>
              </TableCell>
              <TableCell />
              <TableCell align="right">
                {formatNoDecimalBigInt(office.ES)}
              </TableCell>
              <TableCell align="right">
                {formatNoDecimalBigInt(office.EBR)}
              </TableCell>
              <TableCell align="right">
                {formatNoDecimalBigInt(office.ESR)}
              </TableCell>
              <TableCell align="right">
                {formatNoDecimalBigInt(office.EP)}
              </TableCell>
            </TableRow>
          ))}
        </React.Fragment>
      )
    }

    Row.propTypes = {
      row: PropTypes.shape({
        accountName: PropTypes.string.isRequired,
        ES: PropTypes.number,
        EBR: PropTypes.number,
        ESR: PropTypes.number,
        EP: PropTypes.number,
        offices: PropTypes.arrayOf(
          PropTypes.shape({
            officeName: PropTypes.string.isRequired,
            ES: PropTypes.number,
            EBR: PropTypes.number,
            ESR: PropTypes.number,
            EP: PropTypes.number
          })
        ).isRequired
      }).isRequired
    }

    const rows = this.props.accountRevenue.accounts.map(account => {
      return createAccountData(account)
    })

    const headStyles = {
      ...fontStyles,
      fontWeight: 700
    }

    const monthlyTab = (
      <TableContainer
        component={Paper}
        style={{ boxShadow: 'unset', minHeight: 400 }}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell style={headStyles}>Account Name</TableCell>
              <TableCell />
              <TableCell style={headStyles} align="right">
                ES Revenue €
              </TableCell>
              <TableCell style={headStyles} align="right">
                EBR Revenue €
              </TableCell>
              <TableCell style={headStyles} align="right">
                Survey Revenue €
              </TableCell>
              <TableCell style={headStyles} align="right">
                EP Revenue €
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <Row key={row.name} row={row} />
            ))}
            {monthlyTotal(monthlyTotals)}
          </TableBody>
        </Table>
      </TableContainer>
    )

    const quarterlyTab = totals => {
      return (
        <div className="accountRevenue-widget">
          <div className={'accountRevenue-quarterly'}>
            <div
              className={
                'accountRevenue-quarterly-column accountRevenue-quarterly-column-revenue'
              }>
              <div className="revenue-section">
                <h3>Revenue €</h3>
                <div className="month-list">
                  {this.props.accountRevenueQuarterly.months.map(
                    (month, index) => {
                      return month.month ? (
                        <div className="quarterly-month" key={index}>
                          <div className="quarterly-month-label">
                            {month.month}
                          </div>
                          <div className="quarterly-month-value">
                            {formatNoDecimalBigInt(month.revenue)}
                          </div>
                        </div>
                      ) : null
                    }
                  )}
                  <div className="quarterly-month total-month-quarterly">
                    <div className="quarterly-month-label">Total</div>
                    <div className="quarterly-month-value">
                      {formatNoDecimal(totals.revenue)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={'accountRevenue-quarterly-column'}>
              <div className={'total-quarter-target-container'}>
                <div>
                  <Tooltip tooltip="Account Managers Target €">
                    <h3>Target €</h3>
                  </Tooltip>
                  <div className={'total-quarter-target'}>
                    {formatNoDecimal(totals.target)}
                  </div>
                </div>
              </div>
            </div>
            <div className={'accountRevenue-quarterly-column'}>
              <div className={'total-quarter-achievement-container'}>
                <div>
                  <h3>Achievement %</h3>
                  <div className={'total-quarter-achievement'}>
                    {formatDecimal(totals.achievement)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }

    const date = this.props.date
    const monthlyDatePicker = (
      <>
        <div className="widget-box__top-bar__action--opacity">
          <button
            readOnly
            className="accountRevenue-widget__datepicker"
            onClick={this.handleCalendarDisplay}>
            <DateRangeIcon />
            <div className="datepicker-text">{date}</div>
          </button>
        </div>
      </>
    )

    return (
      <WidgetBox
        label="Account Revenue"
        customClass={'account-revenue-container'}
        action={
          <>
            {this.props.accountRevenue.accountManager && (
              <div className="mobile-account-manager-icon">
                <Tooltip
                  tooltip={
                    <div>
                      {this.props.accountRevenue.seniorAccountManager ? (
                        <div>
                          Senior Account Manager:
                          {this.props.accountRevenue.seniorAccountManager}
                        </div>
                      ) : null}
                      <div>
                        Account Manager:
                        {this.props.accountRevenue.accountManager}
                      </div>
                    </div>
                  }
                  method={'click'}>
                  <PeopleIcon className="mobile-menu-icon" />
                </Tooltip>
              </div>
            )}
            <div
              className={`account-revenue-action-section ${
                !this.props.accountRevenue.accountManager ? 'no-manager' : ''
              }`}>
              {this.props.accountRevenue.accountManager && (
                <div
                  style={{ paddingRight: 12 }}
                  className={`account-manager-section ${
                    this.quarterlyTabActive ? 'quarterly-active' : ''
                  }`}>
                  {this.props.accountRevenue.seniorAccountManager ? (
                    <div>
                      <Tooltip
                        tooltip={`Senior Account Manager: ${this.props.accountRevenue.seniorAccountManager}`}>
                        <div>
                          <strong>Senior Account Manager: </strong>
                          {this.props.accountRevenue.seniorAccountManager}
                        </div>
                      </Tooltip>
                    </div>
                  ) : null}
                  <div>
                    <Tooltip
                      tooltip={`Account Manager: ${this.props.accountRevenue.accountManager}`}>
                      <div>
                        <strong>Account Manager: </strong>
                        {this.props.accountRevenue.accountManager}
                      </div>
                    </Tooltip>
                  </div>
                </div>
              )}
              <div className="month-quarter-toggle-container-mobile">
                {!this.quarterlyTabActive && monthlyDatePicker}
              </div>
              <div className="month-quarter-toggle-container-desktop">
                <div className={'dashboard-links month-quarter-toggle-section'}>
                  <button
                    onClick={() => this.setQuarterlyTab(false)}
                    className={`dashboard-link ${
                      !this.quarterlyTabActive ? 'active' : ''
                    }`}>
                    Monthly
                  </button>
                  <button
                    onClick={() => this.setQuarterlyTab(true)}
                    className={`dashboard-link ${
                      this.quarterlyTabActive ? 'active' : ''
                    }`}>
                    Quarterly
                  </button>
                </div>
                {!this.quarterlyTabActive ? (
                  monthlyDatePicker
                ) : (
                  <div className="date-section">
                    <div className="widget-box__top-bar__action--opacity">
                      <Select
                        value={this.props.quarter}
                        options={[
                          {
                            value: 1,
                            label: '1st Quarter'
                          },
                          {
                            value: 2,
                            label: '2nd Quarter'
                          },
                          {
                            value: 3,
                            label: '3rd Quarter'
                          },
                          {
                            value: 4,
                            label: '4th Quarter'
                          }
                        ]}
                        onChange={this.handleQuarterChange}
                        disabled={false}
                      />
                      <Select
                        value={this.props.year}
                        options={this.quarterlyYearOptions(2020)}
                        onChange={this.handleYearChange}
                        disabled={false}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </>
        }>
        <div className="month-quarter-links-mobile">
          <div className={'dashboard-links month-quarter-toggle-section'}>
            <button
              onClick={() => this.setQuarterlyTab(false)}
              className={`dashboard-link ${
                !this.quarterlyTabActive ? 'active' : ''
              }`}>
              Monthly
            </button>
            <button
              onClick={() => this.setQuarterlyTab(true)}
              className={`dashboard-link ${
                this.quarterlyTabActive ? 'active' : ''
              }`}>
              Quarterly
            </button>
          </div>
          {this.quarterlyTabActive && (
            <div className="widget-box__top-bar__action--opacity">
              <Select
                value={this.props.quarter}
                options={[
                  {
                    value: 1,
                    label: '1st Quarter'
                  },
                  {
                    value: 2,
                    label: '2nd Quarter'
                  },
                  {
                    value: 3,
                    label: '3rd Quarter'
                  },
                  {
                    value: 4,
                    label: '4th Quarter'
                  }
                ]}
                onChange={this.handleQuarterChange}
                disabled={false}
              />
              <Select
                value={this.props.year}
                options={this.quarterlyYearOptions(2020)}
                onChange={this.handleYearChange}
                disabled={false}
              />
            </div>
          )}
        </div>

        <div className="mobile-teamRevenue">
          {this.quarterlyTabActive ? (
            quarterlyTab(quarterlyTotals)
          ) : (
            <AccountRevenueMobile total={monthlyTotals} accounts={rows} />
          )}
        </div>
        <div className="desktop-teamRevenue">
          {this.quarterlyTabActive ? quarterlyTab(quarterlyTotals) : monthlyTab}
        </div>
        {this.isCalendarShown && (
          <MonthYearCalendar
            closeCalendar={this.closeCalendar}
            activeMonthAndYear={date}
            onMonthPress={this.onMonthPress}
          />
        )}
      </WidgetBox>
    )
  }
}

export default inject(
  'userStore',
  'dashboardStore'
)(enhanceWithClickOutside(observer(AccountRevenue)))
